module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Lt.b788b2c.ttf";